var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkeletonXl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    viewBox: "0 0 1076 760",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1075,
    height: 759,
    rx: 9.5,
    fill: "white",
    stroke: "#F2F2F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 75,
    width: 1074,
    height: 1,
    fill: "#F2F2F2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 20,
    width: 476,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 42,
    width: 1043,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 151,
    width: 1074,
    height: 1,
    fill: "#F2F2F2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 96,
    width: 476,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 118,
    width: 1043,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 227,
    width: 1074,
    height: 1,
    fill: "#F2F2F2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 172,
    width: 476,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 194,
    width: 1043,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 303,
    width: 1074,
    height: 1,
    fill: "#F2F2F2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 248,
    width: 476,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 270,
    width: 1043,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 379,
    width: 1074,
    height: 1,
    fill: "#F2F2F2"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 324,
    width: 476,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 346,
    width: 1043,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 455,
    width: 1074,
    height: 1,
    fill: "#F2F2F2"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 400,
    width: 476,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 422,
    width: 1043,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 531,
    width: 1074,
    height: 1,
    fill: "#F2F2F2"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 476,
    width: 476,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 498,
    width: 1043,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 607,
    width: 1074,
    height: 1,
    fill: "#F2F2F2"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 552,
    width: 476,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 574,
    width: 1043,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 683,
    width: 1074,
    height: 1,
    fill: "#F2F2F2"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 628,
    width: 476,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 650,
    width: 1043,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 704,
    width: 476,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 726,
    width: 1043,
    height: 14,
    rx: 7,
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkeletonXl);
export default __webpack_public_path__ + "static/media/skeleton_xl.19dc407603e5ebd169114670b2044703.svg";
export { ForwardRef as ReactComponent };